<template>
  <div class="voteBallot" v-if="voteList.length>0">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>投票表决
      </span>
    </div>
    <div class="container" :class="{open:open}">
      <template v-for="(item ,index) in voteList">
        <div :key="index">
          <div class="min-title">
            <div class="vote-subject">
              投票主题：
              <span class="to-detail" @click="toDetail(item)">{{item.VoteTitle}}</span>
            </div>
            <div class="eaAreaInfo">
              <div class="row">
                <div class="col">物业区域名称：{{item.Range.EaAreaName}}</div>
                <div class="col">专有部分面积：{{item.Range.TotalArea}}m²</div>
                <div class="col">专有部分户数：{{item.Range.TotalHouseCount}}户</div>
                <div class="col">专有部分人数：{{item.Range.TotalOwnerCount}}人</div>
              </div>
              <div class="row">
                <div class="col">开始时间：{{item.BeginTime | formatDate('yyyy-MM-dd')}}</div>
                <div class="col">结束时间：{{item.EndTime | formatDate('yyyy-MM-dd')}}</div>
              </div>
            </div>
            <div class="progress">
              <div class="strip">
                <span>投票进度</span>
                <el-progress
                  :percentage="dealprogress(item.EndTime,item.BeginTime)"
                  :show-text="false"
                ></el-progress>
              </div>
              <span>
                <svg-icon icon-class="time" style="color:#0f77f2"></svg-icon>
                已过{{pasttime(item.BeginTime)}}天，剩余{{surplus(item.EndTime)}}天
                <span
                  class="remind"
                >投票提醒</span>
              </span>
            </div>
          </div>
          <div class="theme">
            <template v-for="(child,idx) in item.VoteMatters._Items">
              <div class="box" :key="idx">
                <div class="vote">
                  <div class="vote-title">{{child.ItemTitle}}</div>
                  <div class="charts">
                    <div ref="myChartSatisfaction" :style="{width: '250px', height: '150px'}"></div>
                    <div class="owner">
                      <div class="ownerTotal">
                        <span class="num">{{ item.Range.TotalOwnerCount}}</span>
                        <span>业主总数</span>
                      </div>
                      <div class="partVote">
                        <div ref="partVote" :style="{width: '130px', height: '150px'}"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div class="box" v-if="!(item.VoteMatters._Items.length%2===0)"></div>
          </div>
        </div>
      </template>
      <div class="more">
        <template v-if="!open||!max">
          <div class="mar-r" @click="openVote()">
            加载更多
            <i class="el-icon-arrow-down"></i>
          </div>
        </template>
        <template v-if="closeTitle">
          <div @click="close()">
            收起
            <i class="el-icon-arrow-up"></i>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { VoteControllerSvr } from '@/service/VoteControllerSvr';
import { VoteQueryPara } from '@/models/queryparams/VoteQueryPara';
import { mapState } from 'vuex';
export default {
  components: {},
  props: {},
  data() {
    return {
      voteList: [],
      open: false,
      page: 0,
      size: 3,
      max: false,
      drawIndex: 0,
      closeTitle: false
    };
  },
  computed: {
    ...mapState(['token'])
  },
  created() {
    this.VoteControllerSvr = new VoteControllerSvr();
    this.VoteQueryPara = new VoteQueryPara();
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      if (!this.max) {
        this.VoteControllerSvr.GetVoteList(
          this.token,
          '{}',
          true,
          this.page++ * this.size,
          this.size,
          false
        ).then(res => {
          if (res._Items.length === 0) {
            this.max = true;
          } else {
            this.voteList = this.voteList.concat(res._Items);
            this.drawEchart((this.page - 1) * this.size);
          }
        });
      }
    },
    drawEchart(startIndex) {
      this.$nextTick(() => {
        for (let i = startIndex; i < this.voteList.length; i++) {
          this.voteList[i].VoteMatters._Items.forEach((child, idx) => {
            this.drawPie(
              this.$refs.myChartSatisfaction[this.drawIndex],
              child,
              this.voteList[i].Range.TotalOwnerCount
            );
            this.drawVote(
              this.$refs.partVote[this.drawIndex],
              child,
              this.voteList[i].Range.TotalOwnerCount
            );
            this.drawIndex++;
          });
        }
      });
    },
    drawPie(dom, info, totlNum) {
      //投诉统计
      let myChartSatisfaction = this.$echarts.init(dom);
      var chartName = [];
      var chartData = [];
      info.CandidateItems._Items.forEach(item => {
        chartName.push(item.CandiTitle);
        chartData.push(Math.round(item.VoteHouseCount / totlNum * 100));
      });
      var data = [];
      var legendName = [];
      for (var i = 0; i < chartData.length; i++) {
        var c = {
          value: chartData[i],
          name: chartName[i] + '  ' + chartData[i] + '%'
        };
        data[i] = c;
        legendName[i] = chartName[i] + '  ' + chartData[i] + '%';
      }
      myChartSatisfaction.setOption({
        backgroundColor: '#fff',
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {d}% <br/> {c}'
        },
        graphic: {
          elements: [
            {
              type: 'text',
              style: {
                text: '占比',
                x: 100,
                y: 100,
                textAlign: 'center',
                fill: '#333333',
                font: '16px "MicrosoftYaHei", sans-serif '
              },
              left: '49px',
              top: 'center'
            }
          ]
        },
        legend: {
          orient: 'vertical',
          x: '135px',
          y: 'center',
          itemWidth: 10,
          itemHeight: 10,
          align: 'left',
          textStyle: {
            fontSize: 14,
            color: '#000'
          },
          data: legendName
        },
        series: [
          {
            type: 'pie',
            radius: ['35px', '50px'],
            center: ['65px', '50%'],
            color: [
              '#67aafe',
              '#0f77f2',
              '#ffb400',
              '#F8456B',
              '#00FFFF',
              '#4AEAB0'
            ],
            data: data,
            labelLine: {
              normal: {
                show: false,
                length: 20,
                length2: 20,
                lineStyle: {
                  color: '#12EABE',
                  width: 2
                }
              }
            },
            label: {
              normal: {
                show: false,
                formatter: '{c|{c}}\n{hr|}\n{d|{d}%}',
                rich: {
                  b: {
                    fontSize: 20,
                    color: '#12EABE',
                    align: 'left',
                    padding: 4
                  },
                  hr: {
                    borderColor: '#12EABE',
                    width: '100%',
                    borderWidth: 2,
                    height: 0
                  },
                  d: {
                    fontSize: 20,
                    color: '#fff',
                    align: 'left',
                    padding: 4
                  },
                  c: {
                    fontSize: 20,
                    color: '#fff',
                    align: 'left',
                    padding: 4
                  }
                }
              }
            }
          }
        ]
      });
    },
    drawVote(dom, info, totlNum) {
      //投诉统计
      let myChartSatisfaction = this.$echarts.init(dom);
      let partNum = 0;
      info.CandidateItems._Items.forEach(() => {
        partNum += 1;
      });
      let percentage = Math.round(partNum / totlNum * 100) + '%';
      myChartSatisfaction.setOption({
        // tooltip: {
        //   trigger: 'item',
        //   formatter: '{a} <br/>{b}: {c} ({d}%)'
        // },
        graphic: {
          elements: [
            {
              type: 'text',
              left: 'center',
              top: '50px',
              z: 2,
              zlevel: 100,
              style: {
                text: percentage,
                x: 100,
                y: 100,
                textAlign: 'center',
                fill: '#333333',
                font: '22px "MicrosoftYaHei", sans-serif'
              }
            },
            {
              type: 'text',
              left: 'center',
              top: '75px',
              z: 2,
              zlevel: 100,
              style: {
                text: '参与投票',
                x: 100,
                y: 100,
                textAlign: 'center',
                fill: '#333333',
                font: '14px "MicrosoftYaHei", sans-serif'
              }
            }
          ]
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: ['45px', '50px'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            color: ['#0f77f2', '#e2e2e2'],
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '15',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [{ value: partNum, name: '' }, { value: totlNum, name: '' }]
          }
        ]
      });
    },
    dealprogress(start, end) {
      let startTime = new Date(start);
      let endTime = new Date(end);
      let now = new Date();
      let progress =
        (now - endTime) /
        1000 /
        60 /
        60 /
        24 /
        ((startTime - endTime) / 1000 / 60 / 60 / 24);
      return Math.round(progress * 100);
    },
    pasttime(start) {
      let startTime = new Date(start);
      let now = new Date();
      return Math.floor((now - startTime) / 1000 / 60 / 60 / 24);
    },
    surplus(end) {
      let endTime = new Date(end);
      let now = new Date();
      return Math.floor((endTime - now) / 1000 / 60 / 60 / 24);
    },
    openVote() {
      if (this.open && this.max) {
        this.open = false;
      } else {
        this.open = true;
        this.getData();
        this.closeTitle = true;
      }
      // this.open = !this.open;
    },
    close() {
      this.VoteControllerSvr.GetVoteList(
        this.token,
        '{}',
        true,
        0,
        1,
        false
      ).then(res => {
        if (res._Items.length === 0) {
          this.max = true;
          this.closeTitle = false;
        } else {
          this.closeTitle = false;
          this.voteList = res._Items;
          this.drawEchart((this.page - 1) * this.size);
        }
      });
    },
    // 点击进入投票详情
    toDetail(item) {
      this.$router.push({
        path: 'voteDetail',
        query: { bisKey: item.KeyId, workId: item.WorkId }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.voteBallot {
  background: #fff;
  .container {
    position: relative;
    overflow: hidden;
    padding-bottom: 30px;
    max-height: 350px;
    transition: max-height 0.5s;
    &.open {
      max-height: 99999px;
    }
    .min-title {
      height: 130px;
      background-color: #f2f2f2;
      border-radius: 5px;
      padding: 5px;
      border-left: 10px solid #fff;
      border-right: 10px solid #fff;
      .vote-subject {
        font-size: 14px;
        font-weight: bold;
        line-height: 36px;
        color: #333333;
      }
      .to-detail {
        cursor: pointer;
        &:hover {
          color: #409eff;
        }
      }
      .eaAreaInfo {
        .row {
          display: flex;
          justify-content: flex-start;
          font-size: 14px;
          color: #666;
          margin-bottom: 10px;
          .col {
            width: 210px;
          }
        }
      }
      .progress {
        width: 550px;
        line-height: 25px;
        display: flex;
        justify-content: space-between;
        span {
          font-size: 12px;
        }
        .strip {
          display: flex;
          span {
            margin-right: 16px;
          }
          .el-progress {
            top: 11.5px;
            width: 280px;
          }
        }
        .remind {
          padding: 0 6px;
          border-radius: 5px;
          background: #0f77f2;
          color: #fff;
          cursor: pointer;
        }
      }
    }
    .theme {
      padding-top: 10px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      border-bottom: 1px solid #e2e2e2;
      .box {
        flex: 0 1 50%;
        min-width: 480px;
        max-width: 660px;
        .vote {
          height: 180px;

          .vote-title {
            position: relative;
            padding-left: 15px;
            font-size: 14px;
            &::after {
              position: absolute;
              left: 8px;
              top: 2px;
              content: '';
              width: 4px;
              height: 10px;
              background: #0f77f2;
            }
          }
          .charts {
            display: flex;
            justify-content: space-between;
            .owner {
              flex: 1;
              min-width: 230px;
              display: flex;
              justify-content: space-around;
              .ownerTotal {
                margin-top: 25px;
                width: 100px;
                height: 100px;
                border: 5px solid #0f77f2;
                border-radius: 50%;
                span {
                  display: block;
                  text-align: center;
                }
                .num {
                  display: block;
                  margin-top: 18px;
                  font-size: 25px;
                }
              }
            }
          }
        }
      }
      .line {
        width: 1px;
        height: 180px;
        background: #e2e2e2;
      }
    }
    .more {
      display: flex;
      justify-content: center;
      position: absolute;
      bottom: 0;
      width: 100%;
      background: #fff;
      font-size: 14px;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
      &>div{
        transition: all .3s;
        &:hover{
          color: #4a94df;
        }
      }
      i {
        font-size: 18px;
      }
    }
  }
}
</style>